import React from 'react';
import { Card, Avatar, Divider } from 'antd';
import { LikeOutlined } from '@ant-design/icons';

const GraphicCard = ({ imgUrl, title, description, iconUrl, onClick, height=130, width=220,
                     className='', borderRadius='4px',
                      boxShadow='none'
}) => {
  const coverStyle = {
    position: 'relative', // Relative because the icon inside will be absolute
    width: '100%',
    height: `${height}px`, // Changed to 100% of the parent's height
    borderRadius: borderRadius

  };

  const coverImgStyle = {
    width: '100%',
    height: '100%', // Changed to 100% of the parent's height
    // objectFit: 'contain',
    objectPosition: 'center',
    borderRadius: borderRadius,
    boxShadow: boxShadow

  };

  const iconStyle = {
    position: 'absolute', // Absolutely position the icon to the bottom of the image
    left: '10%', // Center the icon horizontally with respect to its container
    bottom: '0', // Move it upwards by half its height to achieve the half on and off effect
    transform: 'translate(-50%, 50%)', // Adjust horizontal centering and move it up 50% of its own height
    backgroundColor: '#FFF', // Assuming you want a transparent background
    borderRadius: '25%', // Make it circular
    padding: '0',
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
  };

  const cardStyle = {
    width: width,
    overflow: 'hidden',
    margin: '0 auto',

  };

  return (
    <Card
      className={`graphic-card ${className}`}
      bordered={false}
      hoverable
      style={cardStyle}
      cover={
        <div className={'img-cover'} style={coverStyle}>
          <img alt={title} src={imgUrl} style={coverImgStyle} />
          {iconUrl && <Avatar src={iconUrl} alt="Icon" size="large" style={iconStyle} />}
        </div>
      }
      onClick={onClick}
      actions={[

      ]}
    >
      <Card.Meta style={{paddingTop: '30px'}} title={title} description={description} />
    </Card>
  );
};

export default GraphicCard;
